document.addEventListener("DOMContentLoaded", function () {
    const buttons = document.querySelectorAll(".see-more-btn");
    const hiddenItems = document.querySelectorAll("#feature-list .hidden");

    buttons.forEach(btn => {
        btn.addEventListener("click", function () {
            hiddenItems.forEach(el => el.classList.remove("hidden"));
            btn.style.display = "none"; // Hide only the clicked button
        });
    });
});
